import { openModal } from "@chef/state-management";
import { useAppDispatch } from "@chef/state-management/hooks";

import { RecipeRating } from "./RecipeRating";

import { intl } from "./RatingAndCommentContainer.Intl";

interface RecipeProps {
  recipeId: number;
  recipeName: string;
}

interface RatingAndCommentContainerProps {
  display?: boolean;
  id?: string;
  recipe: RecipeProps;
  ratingData: {
    rating?: number;
    comment?: string;
    quickCommentIds?: string[];
  };
}

export const RatingAndCommentContainer = ({
  id,
  ratingData,
  recipe,
  display = false,
}: RatingAndCommentContainerProps) => {
  const dispatch = useAppDispatch();
  const { recipeId, recipeName } = recipe;

  if (!display) {
    return null;
  }

  return (
    <section id={id}>
      <div className="px-2 py-4 lg:px-4 bg-background">
        <div className="text-xs">
          <strong>
            {ratingData?.rating
              ? intl.THANK_YOU_FOR_RATING
              : intl.GIVE_US_YOUR_RATING}
          </strong>
        </div>
        <button
          onClick={() =>
            dispatch(
              openModal({
                id: "RATING_AND_COMMENT",
                recipeId,
                recipeName,
                ratingData,
              }),
            )
          }
        >
          <RecipeRating
            recipeId={recipeId}
            rating={ratingData?.rating || 0}
            readOnly
          />
        </button>
      </div>
    </section>
  );
};
